import { Routes, Route } from "react-router-dom";
import Layout from "../layout/index.js";
import Dashboard from '../pages/SuperAdmin/dahboard.js';
import EditProfile from '../components/EditProfile';
import Applications from "../pages/SuperAdmin/Applications.js";
import UserTable from "../pages/SuperAdmin/UserTable.js";
import ReportDashboard from "../components/Reports/index.js";
import Students from "../pages/SuperAdmin/Students.js";
import ChangePassword from "../components/ChangePassword/index.js";
import ScholarshipInviteLinks from "../pages/SuperAdmin/ScholarshipInviteLinks.js";
import GpaWarnings from "../pages/SuperAdmin/GpaWarnings.js";
import ApprovalTracker from "../pages/SuperAdmin/ApprovalTracker.js";

const adminRoutesData = [
  { path: "", element: <Dashboard />, text: "Dashboard" },
  { path: "applications", element: <Applications />, text: "Applications" },
  { path: "students", element: <Students />, text: "Students" },
  { path: "partner", element: <UserTable role="vendor"/>, text: "Partners" },
  { path: "scholarship-links", element: <ScholarshipInviteLinks />, text: "Scholarship Links" },
  { path: "gpa-warnings", element: <GpaWarnings />, text: "GPA Warnings" },
  { path: "scholarship-reviewer", element: <UserTable role="reviewer"/>, text: "Scholarship Reviewer" },
  { path: "scholarship-approver", element: <UserTable role="approver"/>, text: "Scholarship Approver" },
  { path: "record-keeper", element: <UserTable role="record-keeper"/>, text: "Record Keeper" },
  { path: "finance", element: <UserTable role="finance"/>, text: "Finance Admin" },
  { path: "approval-tracker", element: <ApprovalTracker />, text: "Approval Tracker" },
  { path: "reports", element: <ReportDashboard />, text: "Reports" },
];

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout navItems={adminRoutesData} />}>
        {adminRoutesData.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;